export const SCREEN_NAMES = [
  'balance',
  'packages',
  'payment',
  'draws-history',
  'draw-participants',

  'games',
  'cases',
  'case-details',
  'case-roulette',
  'case-honeycomb',
  'case-open-results',
  'shop',
  'shop-skins',
  'shop-items',
  'shop-item',
  'upgrade',
  'rush-mid',
  'arena',
  'rush-mid-match-detail',
  'rush-mid-open-game',
  'rush-mid-spectate',
  'rush-mid-replay',
  'rush-mid-raffle-round',
  'rush-mid-raffle-winners',
  'rush-mid-survey',
  'roulette',
  'roulette-match',
  'case-battles',
  'case-battle-create',
  'case-battle-details',
  'case-battle-history',
  'giveaway-details',
  'daily-giveaway-details',
  'daily-giveaway-details-winners',
  'rains',
  'rain-details',

  'inventory',
  'inventory-item',
  'send-item',

  'contracts',

  'referrals',
  'referral-contest',

  'band',
  'band-shelf',
  'band-raffle-round',
  'band-raffle-winners',
  'band-race',
  'band-race-winners',
  'band-final',
  'band-final-winners',

  'profile',
  'settings',
  'trade-link',
  'promocode',
  'wheel',
  'language',
  'level-info',
  'xp-history',
  'achievements',
  'steam-inventory',
  'cs2-link',
  'cs2-matches',
  'recruiter-guide',

  'onboarding',
  'onboarding-item-reveal',
  'onboarding-tasks',
  'onboarding-skin-decision',
  'onboarding-friends',
  'onboarding-bonus',
] as const;

export type ScreenName = (typeof SCREEN_NAMES)[number];

export interface ScreenParams {
  [key: string]: unknown;
}

export interface ScreenStackItem {
  screen: ScreenName;
  params?: ScreenParams;
}

export interface TabStack {
  balance: ScreenStackItem[];
  cases: ScreenStackItem[];
  games: ScreenStackItem[];
  inventory: ScreenStackItem[];
  referrals: ScreenStackItem[];
  profile: ScreenStackItem[];
  onboarding: ScreenStackItem[];
  shop: ScreenStackItem[];
}

export interface NavigationState {
  activeTab: keyof TabStack;
  stacks: TabStack;
}

export type NavigationAction =
  | { type: 'CHANGE_TAB'; tab: keyof TabStack }
  | { type: 'PUSH_SCREEN'; tab: keyof TabStack; screen: ScreenName; params?: ScreenParams }
  | { type: 'REPLACE_SCREEN'; tab: keyof TabStack; screen: ScreenName; params?: ScreenParams }
  | { type: 'POP_SCREEN'; tab: keyof TabStack }
  | { type: 'RESET_STACK'; tab: keyof TabStack; screen: ScreenName; params?: ScreenParams }
  | { type: 'UPDATE_SCREEN_PARAMS'; tab: keyof TabStack; params: ScreenParams };
